import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "files-list card-footer",
  "data-testing": "files-card-footer"
}
const _hoisted_4 = {
  "data-testing": "files-card-footer-btn-add-file",
  class: "card-footer-item"
}

import { computed, PropType } from "vue";
import Collapse from "@/components/right-sidebars/ui/Collapse.vue";
import Attachments from "@/components/right-sidebars/content-sidebar/authoring-tool/Attachments.vue";
import MediaContent from "@/components/right-sidebars/content-sidebar/authoring-tool/MediaContent.vue";
import MCQ from "@/components/right-sidebars/content-sidebar/authoring-tool/MCQ.vue";
import QTI from "@/components/right-sidebars/content-sidebar/authoring-tool/QTI.vue";
import HTMLEditor from "@/components/right-sidebars/content-sidebar/authoring-tool/HTMLEditor.vue";
import Hint from "@/components/Hint.vue";
import { ProductFeature, ProductItem } from "@/models/product.model";
import { ContentStructureSection } from "@/models/content-structure.model";
import { mdiPlus } from "@mdi/js";
import { useUIFilesStore } from "@/stores/ui-files.store";
import { TOOLS } from "@/constants/template.constants";
import { PRODUCT } from "@/constants/product.constants";
import QuestionEditor from "@/components/right-sidebars/content-sidebar/authoring-tool/QuestionEditor.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthoringTool',
  props: {
  product: {
    type: Object as PropType<ProductItem>,
    required: true
  },
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  },
  isAContentObject: {
    type: Boolean,
    required: true
  },
  XAPIErrors: {
    type: Array as PropType<string[]>,
    required: false,
    default: () => []
  },
  XAPIWarnings: {
    type: Array as PropType<string[]>,
    required: false,
    default: () => []
  }
},
  emits: ["previewAttachment"],
  setup(__props, { emit: __emit }) {

const uiFilesStore = useUIFilesStore();

const props = __props;

const isContentAuthoringTier2UserFeatureEnabled = computed<boolean>(() => {
  const feature = props.product.features.find(
    (feature: ProductFeature): boolean => {
      return feature.id === PRODUCT.FEATURES.contentAuthoringTier2.id;
    }
  );
  return !!feature && feature.isEnabled;
});

const isAuthoringTool = computed<boolean>(() => {
  return props.section.type.tool_id > 0;
});

const isContentEmpty = computed<boolean>(() => {
  return !isAuthoringTool.value && props.section.enabled_files.length === 0;
});
const hasMCQAuthoring = computed<boolean>(() => {
  return props.section && TOOLS.isMCQTool(props.section.type.tool_id);
});
const hasQTIAuthoring = computed<boolean>(() => {
  return props.section && TOOLS.isQTITool(props.section.type.tool_id);
});
const hasHTMLAuthoring = computed<boolean>(() => {
  return props.section && TOOLS.isHTMLTool(props.section.type.tool_id);
});
const hasExternalContentAuthoring = computed<boolean>(() => {
  return (
    props.section && TOOLS.isExternalContentTool(props.section.type.tool_id)
  );
});
const hasQuestionAuthoring = computed<boolean>(() => {
  return (
    props.section && TOOLS.isQuestionAuthoringTool(props.section.type.tool_id)
  );
});

const openFileModal = (): void => {
  uiFilesStore.openAttachFileModal({ section: props.section });
};
const emit = __emit;
const previewAttachment = (fileLocation: string): void => {
  emit("previewAttachment", fileLocation);
};

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createBlock(Collapse, { "is-content-empty": isContentEmpty.value }, _createSlots({
    title: _withCtx(() => [
      (!isAuthoringTool.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Attachments"))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Authoring Tool")),
      (__props.XAPIErrors.length > 0)
        ? (_openBlock(), _createBlock(Hint, {
            key: 2,
            type: 'error',
            position: 'top'
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.XAPIErrors, (error, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.XAPIWarnings.length > 0)
        ? (_openBlock(), _createBlock(Hint, {
            key: 3,
            type: 'warning',
            position: 'top'
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.XAPIWarnings, (error, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      (hasExternalContentAuthoring.value)
        ? (_openBlock(), _createBlock(MediaContent, {
            key: 0,
            section: __props.section,
            onPreviewAttachment: previewAttachment
          }, null, 8, ["section"]))
        : _createCommentVNode("", true),
      (hasMCQAuthoring.value)
        ? (_openBlock(), _createBlock(MCQ, {
            key: 1,
            section: __props.section,
            "is-content-authoring-tier2-feature-enabled": 
          isContentAuthoringTier2UserFeatureEnabled.value
        
          }, null, 8, ["section", "is-content-authoring-tier2-feature-enabled"]))
        : _createCommentVNode("", true),
      (hasQTIAuthoring.value)
        ? (_openBlock(), _createBlock(QTI, {
            key: 2,
            section: __props.section,
            "is-content-authoring-tier2-feature-enabled": 
          isContentAuthoringTier2UserFeatureEnabled.value
        
          }, null, 8, ["section", "is-content-authoring-tier2-feature-enabled"]))
        : _createCommentVNode("", true),
      (hasHTMLAuthoring.value)
        ? (_openBlock(), _createBlock(HTMLEditor, {
            key: 3,
            section: __props.section,
            "is-content-authoring-tier2-feature-enabled": 
          isContentAuthoringTier2UserFeatureEnabled.value
        
          }, null, 8, ["section", "is-content-authoring-tier2-feature-enabled"]))
        : _createCommentVNode("", true),
      (hasQuestionAuthoring.value)
        ? (_openBlock(), _createBlock(QuestionEditor, {
            key: 4,
            section: __props.section,
            "is-content-authoring-tier2-feature-enabled": 
          isContentAuthoringTier2UserFeatureEnabled.value
        
          }, null, 8, ["section", "is-content-authoring-tier2-feature-enabled"]))
        : _createCommentVNode("", true),
      _createVNode(Attachments, {
        section: __props.section,
        onPreviewAttachment: previewAttachment
      }, null, 8, ["section"])
    ]),
    _: 2
  }, [
    (!isAuthoringTool.value)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("footer", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "btn-3",
                  type: "button",
                  onClick: openFileModal
                }, [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiPlus) }, null, 8, ["path"]),
                  _createTextVNode(" Add attachment ")
                ])
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["is-content-empty"]))
}
}

})